// 引入封装好的request
import request from "@/utills/requestNew";

// 详情
export const designerCaseList = (data) => {
    return request({
        url: 'product/c/crm/designerCase/list2?designerDeptId='+data,
        method: 'GET',
    })
}

// 字典表
export const getDictDataTypes = (data) => {
    return request({
        url: 'system/dict/data/types/'+data,
        method: 'GET',
    })
}
// 案例详情
export const caseDetails = (data) => {
    return request({
        url: 'product/c/crm/designerCase/'+data,
        method: 'GET',
    })
}
// 设计师列表
export const designerList = (data) => {
    return request({
        url: 'product/c/crm/designer/listToTerminal?designerDeptId='+data,
        method: 'GET',
    })
}
// 设计师详情
export const designerDetails = (designerId) => {
    return request({
        url: 'product/c/crm/getDesignerById/'+designerId,
        method: 'GET',
    })
}

// 设计师详情下的案例列表
export const designerCaseListById = (designerId) => {
    return request({
        url: 'product/c/crm/designerCase/list2?caseDesignerId='+designerId,
        method: 'GET',
    })
}
// 预约设计师
export const DesignerAppointment = (data) => {
    return request({
        url: 'product/c/sys/appointmentToTerminal',
        method: 'POST',
        data:data
    })
}
// 首页轮播图
export const bannerList = (position) => {
    return request({
        url: 'product/c/banner/list?position='+position,
        method: 'GET',
    })
}
// 推荐案例
export const RecommendedCases = () => {
    return request({
        url: 'product/c/crm/designerCaseMain?pageNum=1&pageSize=5',
        method: 'GET',
    })
}
// 推荐案例
export const productDetails = (type) => {
    return request({
        url: 'product/c/articles/listToScreen?type='+type,
        method: 'GET',
    })
}
// 活动详情
export const EventDetails = (id) => {
    return request({
        url: 'product/c/getActivity/'+id,
        method: 'GET',
    })
}
// 广告列表
export const advertisingList = () => {
    return request({
        url: 'product/c/advertisementList',
        method: 'GET',
    })
}
// 直播列表
// 
export const liveList = () => {
    return request({
        url: 'product/c/liveList',
        method: 'GET',
    })
}
// 门店列表
export const storeListAll = () => {
    return request({
        url: 'product/c/sys/storeList',
        method: 'GET',
    })
}
// 视频广告打开时间
export const advertisementTime = () => {
    return request({
        url: 'product/c/terminalConfig?configKey=advertisement_time',
        method: 'GET',
    })
}